import { render, staticRenderFns } from "./counterTag.vue?vue&type=template&id=326cd721&"
import script from "./counterTag.vue?vue&type=script&lang=js&"
export * from "./counterTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326cd721')) {
      api.createRecord('326cd721', component.options)
    } else {
      api.reload('326cd721', component.options)
    }
    module.hot.accept("./counterTag.vue?vue&type=template&id=326cd721&", function () {
      api.rerender('326cd721', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/counterTag.vue"
export default component.exports